import React from 'react';
import { useTitleTranslation } from './useTitleTranslation';


export interface ChangeTitleListenerProps {
  basePath?: string,
  omitRootTitle?: boolean
}
export const ChangeTitleListener: React.FC<ChangeTitleListenerProps> = ({basePath, omitRootTitle = false}) => {
  useTitleTranslation(basePath, omitRootTitle);
  return null;
};